import { ChartDetailContainer } from '@/features/(charts)/chart-detail/ui/chart-detail-container';

const ChartCreatePage = () => {
  return <ChartDetailContainer />;
};

export default ChartCreatePage;
